import React from 'react';
import './App.css';
import Register from '../src/pages/Register'
import Login from '../src/pages/Login'
import {BrowserRouter as Router, Routes, Route, useNavigate} from 'react-router-dom'
import {  Grid} from '@mui/material'
import Main from './pages/Main'
import PasswordReset from './pages/ResetPassword'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {AlertPopupContext} from './components/general/AlertPopupContext'
import { selectGlobalDataState, clearMessage, setShouldLogout, setTransactionHasBeenMade } from '../src/features/global/globalDataSlice'
import { closeUanatacaDialog, selectUtilityState } from './features/utilities/utilitySlice';
import { setShouldFetchContracts } from '../src/features/myContracts/myContractsSlice'
import { setIsLoading, setIsManualRegistration } from '../src/features/login/loginSlice'
import {useDispatch, useSelector} from 'react-redux'
import ForgotUserMain from '../src/components/login/forgotUser/forgotUserMain'
import ForgotUser from '../src/components/login/forgotUser/forgotUser'
import ForgotPassword from './pages/ForgotPassword';
import PopularQuestions from './components/main/popularQuestions/PopularQuestions';
import RequestSent from './components/login/forgotUser/requestSent'
import { selectRegistrationState, resetRegistrationState } from './features/registration/registrationSlice';
import PrivateRoute from './components/general/PrivateRoute'
import {CardOnFile} from './components/main/topUp/cardOnFile/CardOnFile'
import { sendGeneralRequest } from './features/generalRequest'
import moment from 'moment'
import {texts} from '../src/components/general/texts'
import UpdateIdCard from './components/login/UpdateIdCard';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import OtpPrompt from './components/main/topUp/cardOnFile/OtpPrompt';
import { selectBasicAccountState, setTransactionIdToCancel, setShouldMakeBasicAccountPaymentVoid } from './features/basicAccount/basicAccountSlice';
import { useLocation } from 'react-router-dom'
import * as config from './components/config'
import {initializeApp} from "firebase/app";
import {getAnalytics, logEvent} from "firebase/analytics";
import UanatacaDialog from './components/general/uanataca/Uanataca';

function App() {
  const app = initializeApp(config.default.firebaseConfig)
  const analytics = getAnalytics(app)
  const globalDataSliceState = useSelector(selectGlobalDataState)
  const utilitySliceState = useSelector(selectUtilityState)
  const registrationSliceState = useSelector(selectRegistrationState)
  const basicAccountSliceState = useSelector(selectBasicAccountState)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [alert, setAlert] = React.useState({
    shouldPopUp: false,
    type: 'success',
    message: ''
  })

   React.useEffect(()=>{
     logEvent(analytics,'page_view', 
      {
        page_location: location.pathname, 
        client_id: globalDataSliceState.token
      }
     )
   },[location.pathname])

  React.useEffect(()=> {
    //texts.setLanguage('al')
    if(globalDataSliceState.shouldDisplayMessage)
    {
      popUpAlert(globalDataSliceState.generalMessage.type, globalDataSliceState.generalMessage.message)
      dispatch(clearMessage())
    }
  },[globalDataSliceState.shouldDisplayMessage, texts])

  React.useEffect(()=> {
    if(basicAccountSliceState.shouldMakeBasicAccountPaymentVoid)
    {
      dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token, orderId: basicAccountSliceState.transactionIdToCancel}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'}))
      dispatch(setTransactionIdToCancel(''))
      dispatch(setShouldMakeBasicAccountPaymentVoid(false))
    }
  },[basicAccountSliceState.shouldMakeBasicAccountPaymentVoid])

  React.useEffect(()=>{
    if(globalDataSliceState.shouldLogout)
    {
      dispatch({type: 'USER_LOGOUT'})
      dispatch(setShouldLogout(false))
      navigate('/login')
    }
  },[globalDataSliceState.shouldLogout])


  React.useEffect(()=>{
    if
    (
      (
        globalDataSliceState.isLoggedIn && 
        (
             performance.navigation.type === 0 
          || performance.navigation.type === 1
          || registrationSliceState.isRegistrationFinished 
          || globalDataSliceState.transactionHasBeenMade
        )
      )
    )
    {
      dispatch(sendGeneralRequest({request: { token: globalDataSliceState.token, fromDate: globalDataSliceState.fromDate, toDate: globalDataSliceState.toDate}, baseUrlKey:'services', endpoint:'GetStatement'}))
      dispatch(sendGeneralRequest({request: { token: globalDataSliceState.token }, baseUrlKey:'services', endpoint:'GetAccountInfoNew'}))
      dispatch(sendGeneralRequest({request: {_request: {TypeOfAccount: globalDataSliceState.accountType } }, baseUrlKey:'auth', endpoint:'GetTermsAndConditions'}))
      dispatch(sendGeneralRequest({request: {_request:{ token: globalDataSliceState.token }}, baseUrlKey:'auth', endpoint:'ValidateTokenNew'})).then(response => {
        if (response.payload.response.success){
          dispatch(setIsManualRegistration(response.payload.response.isManualRegistration))
        }
      })
      dispatch(sendGeneralRequest({request: { token: globalDataSliceState.token }, baseUrlKey:'services', endpoint:'InviteFriend/CheckInviteFriend'}))
      dispatch(sendGeneralRequest({request: { token: globalDataSliceState.token }, baseUrlKey:'services', endpoint:'GetBalance'}))
      dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: "services", endpoint: "News/GetAll",}));
      // dispatch(setShouldFetchContracts(true))

      registrationSliceState.isRegistrationFinished && dispatch(resetRegistrationState())
      
      globalDataSliceState.transactionHasBeenMade && dispatch(setTransactionHasBeenMade(false))
    }
    
   

  },[performance.navigation, registrationSliceState.isRegistrationFinished, globalDataSliceState.transactionHasBeenMade, globalDataSliceState.isLoggedIn])

  const handleAlertClose = () => 
  {
    setAlert({...alert, shouldPopUp: false})
  }

  const popUpAlert = (type, message) => 
  {
    if(message !== "" && message !== null) { 
      setAlert({...alert, shouldPopUp: true, type: type, message: message})
    }
  }

  const handleCloseDialog = () => {
    dispatch(closeUanatacaDialog())
  }

  return (
  
  //   <Detector
  //   render={({ online }) => (
  //     <>{console.log(online)}</>
  //   )}
  // />
      <AlertPopupContext.Provider value={popUpAlert}>
          <div className='App'>           
               <Routes>
                <Route element={<PrivateRoute/>}>
                  <Route path="idCardUpload" element={<UpdateIdCard/>}/>
                </Route>
                  <Route path="*" element={<Main/>}/>
                  <Route path="forgotUserMain" element={<ForgotUserMain/>}/> 
                  <Route path="forgotUser" element={<ForgotUser/>}/>
                  <Route path="popularQuestions" element={<PopularQuestions/>}/>
                  <Route path="requestSent" element={<RequestSent/>}/>
                  <Route path="forgotPassword" element={<ForgotPassword/>}/>
                  <Route path="register" element={<Register/>}/>
                  <Route path="/" element={<Login/>}/>
                  <Route path="login" element={<Login/>}/> 
                  <Route path="resetpassword" element={<PasswordReset/>}/>
                  <Route path="cardOnFileTest" element={<CardOnFile/>}/>   
                  <Route path="otpPrompt" element={<OtpPrompt/>}/>                            
              </Routes> 
              <Grid container item md={8} justifyContent='center'>
                <Snackbar sx={{paddingBottom:'3%'}} anchorOrigin={{vertical: "bottom", horizontal: "center"}} open={alert.shouldPopUp} onClose={handleAlertClose} >
                  <Alert 
                    variant='filled' 
                    severity={alert.type} 
                    sx={{ width: '100%' }}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          handleAlertClose();
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    > 
                  {alert.message}

                  </Alert>
                </Snackbar>
              </Grid>      
            <UanatacaDialog isDialogOpened={utilitySliceState.isUanatacaDialogOpen} handleCloseDialog={handleCloseDialog} />
          </div>    
      </AlertPopupContext.Provider>  
   
  );
}

export default App;